<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert, useTrack } from 'dashboard/composables';
import { CAMPAIGN_TYPES } from 'shared/constants/campaign.js';
import { CAMPAIGNS_EVENTS } from 'dashboard/helper/AnalyticsHelper/events.js';

import EmailCampaignForm from 'dashboard/components-next/Campaigns/Pages/CampaignPage/EmailCampaign/EmailCampaignForm.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['close']);

const store = useStore();
const { t } = useI18n();

const addCampaign = async campaignDetails => {
  try {
    await store.dispatch('campaigns/create', campaignDetails);

    useTrack(CAMPAIGNS_EVENTS.CREATE_CAMPAIGN, {
      type: CAMPAIGN_TYPES.ONE_OFF,
    });

    useAlert(t('CAMPAIGN.EMAIL.CREATE.FORM.API.SUCCESS_MESSAGE'));
  } catch (error) {
    const errorMessage =
      error?.response?.message ||
      t('CAMPAIGN.EMAIL.CREATE.FORM.API.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};

const handleSubmit = campaignDetails => {
  addCampaign(campaignDetails);
};

const handleClose = () => emit('close');
</script>

<template>
  <Teleport to="body">
    <div
      role="dialog"
      aria-modal="true"
      class="tic-campaign-dialog fixed z-[10000] flex min-w-0 flex-col overflow-hidden rounded-xl border shadow-xl"
    >
      <div class="tic-campaign-dialog__header">
        <h3 class="m-0 text-base font-semibold text-n-slate-12">
          {{ t('CAMPAIGN.EMAIL.CREATE.TITLE') }}
        </h3>
        <Button
          ghost
          slate
          icon="i-lucide-x"
          type="button"
          @click="handleClose"
        />
      </div>
      <div class="tic-campaign-dialog__body">
        <EmailCampaignForm @submit="handleSubmit" @cancel="handleClose" />
      </div>
    </div>
  </Teleport>
</template>
